import React, { useState, useEffect } from 'react'
import ReactTable from 'react-table'
import { Link } from 'react-router-dom'
import { useQuery } from '@apollo/react-hooks'
import {
  AutoComplete, message, Modal, DatePicker,
} from 'antd'
import moment from 'moment'
import _ from 'lodash'
import axios from 'axios'
import fileDownload from 'js-file-download'
import {
  Div, Button, Icon, Input, H3, DynamicButtonLink, Loading, P,
  H4,
} from 'konsys-ui'
import { theme } from '../../../styles/_variables'
import { Wrapper } from '../../../components/tire-inventory-components'
import {
  TIRE_INVENTORIES, TIRE_SERIAL_NUMBER_LIST,
} from '../../../constants/graph/query'
import { ListContainer, Select } from '../../../components/common'
import { getAccessToken, getURL } from '../../../utils/local-data-service'
import { PAYMENT_TYPE } from '../constants'
import './style-css.css'
import PERMISSION from '../../../constants/permissions'
import config from './config'

const { color } = theme

const TireUsageModal = ({
  tireUsageModal, setTireUsageModal, isLoading, setIsLoading,
}) => {
  const [date, setDate] = useState()
  return (
    <Modal
      title="เลือกเดือน"
      visible={tireUsageModal}
      destroyOnClose={true}
      onCancel={() => {
        setTireUsageModal(false)
        setDate()
      }}
      onOk={() => {
        setIsLoading(true)
        axios({
          method: 'GET',
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          url: `${getURL().FILE_SERVER}/download/excel/tire/movementLogs?${
            [
              `startDate=${moment(date).startOf('month').format('YYYY-MM-DD')}`,
              `endDate=${moment(date).endOf('month').format('YYYY-MM-DD')}`,
            ].join('&')
          }`,
        }).then((resp) => {
          fileDownload(resp.data, `รายงานการใช้ยางรายเดือน ${moment(date).format('YYYY-MM')}.xlsx`)
          setIsLoading(false)
          setTireUsageModal(false)
          setDate()
        })
      }}
      okButtonProps={{
        disabled: isLoading || _.isUndefined(date),
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      <Div alignItems='center' display='flex' flexDirection='row'>
        <P margin = '0 32px 0 0'>เลือกเดือน</P>
        <DatePicker.MonthPicker
          format='MM/YYYY'
          onChange={(e) => {
            setDate(e)
          }}
        />
      </Div>
    </Modal>
  )
}

const Index = () => {
  const [serial, setSerial] = useState()
  const [serialSearch, setSerialSearch] = useState()
  const [tireUsageModal, setTireUsageModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const {
    data: serialData, loading: serialLoading, error: serialError, fetchMore: serialFetchMore, refetch: serialRefetch,
  } = useQuery(TIRE_SERIAL_NUMBER_LIST, { variables: { limit: 5, serialNumber: serialSearch } })
  return (
  <Div display='flex' flexDirection='column'>
    <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
      <H3 bold color={color.primaryColor} margin='32px 0'>สต๊อกยาง</H3>
      <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
        { (!serialLoading || !_.isEmpty(serialData))
          && <AutoComplete
          dataSource={serialData.TireSerialNumberList.lists.map(v => v.serialNumber)}
          value={serialSearch}
          style={{ width: 200 }}
          onSelect={(e) => {
            setSerial(e)
            setSerialSearch(e)
          }}
          onSearch={(e) => {
            if (e === '') {
              setSerial()
              setSerialSearch()
            } else {
              setSerialSearch(e)
            }
          }}
          placeholder="ใส่รหัสserial"
          />
        }
        <Div>
        <Button
          text='พิมพ์งานการใช้ยางรายเดือน'
          icon='fas fa-print'
          onClick={() => {
            setTireUsageModal(true)
          }}
          margin='0 0 0 16px'
        />
        <DynamicButtonLink link='/tire-inventory/add' condition={_.includes(window.perms, PERMISSION.CREATE_TIRE_INVENTORY)} props={{ text: 'เพิ่มสินค้า', margin: '0 16px' }} />
        </Div>
      </Div>
    </Div>
    <List serial={serial} />
      <TireUsageModal
      tireUsageModal={tireUsageModal}
      setTireUsageModal={setTireUsageModal}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      />
  </Div>
  )
}

export const List = ({ serial }) => {
  const [current, setCurrent] = useState(0)
  const [variable, setVariable] = useState({})
  const {
    data, loading, error, fetchMore, refetch,
  } = useQuery(TIRE_INVENTORIES, {
    variables: {
      ...variable,
      limit: 5,
      offset: 5 * current,
    },
  })
  useEffect(() => {
    refetch({ serials: serial })
  }, [serial])
  return (
    <Wrapper overflow padding='0 0 40px 0'>
      {loading && _.isEmpty(data) && <Loading center='true' />}
      {
        (!_.isNil(data))
        && (
          <h4 className='text-base'>สินค้าทั้งหมด: <span style={{ color: color.primaryColor, fontWeight: 700 }}>{data.TireList.totalCount}</span></h4>
        )
      }
      {
        (!_.isNil(data))
        && (
          <h4 className='text-base'>สินค้าที่มีจำนวนต่ำกว่าสต๊อกขั้นต่ำ: <span style={{ color: color.primaryColor, fontWeight: 700 }}>{data.TireList.lowStockCount}</span></h4>
        )
      }
      {(!loading || !_.isEmpty(data))
        && <Div>
          <ReactTable
            className='table'
            data={data.TireList.lists}
            resizable={false}
            columns={config.columns}
            minRows={5}
            manual
            // defaultPageSize={10}
            showPageSizeOptions={false}
            getTdProps={() => ({ disabled: true, serial })} // *
            getTrProps={(state, rowInfo) => { // *
              if (rowInfo) {
                const stock = _.sumBy(rowInfo.original.inventoryOptions[0].stockLocation, location => location.quantity)
                const minimumStock = rowInfo.original.inventoryOptions[0].minimumStock || 0
                const isLowStock = stock < minimumStock
                return {
                  style: {
                    padding: '8px 0',
                    backgroundColor: isLowStock ? `rgba(${color.primaryColorRGB}, 0.3)` : '#ffffff',
                    borderLeft: `3px solid ${color.primaryColor}`,
                  },
                }
              } return {}
            }}
            previousText='ก่อนหน้า'
            nextText='ถัดไป'
            pageText='หน้า'
            ofText='จาก'
            page={current}
            pages={Math.ceil(data.TireList.totalFilter / 5)}
            onPageChange={page => setCurrent(page)}
            onFilteredChange={async (newFiltered) => {
              const newOjb = {
                sku: '',
                productName: '',
                brand: '',
                supplierName: '',
                rims: '',
                width: '',
                series: '',
                tireTypeName: '',
                lowStock: false,
              }
              await newFiltered.forEach((v) => {
                if (v.id === 'inventory.sku') {
                  Object.assign(newOjb, { sku: v.value })
                } else if (v.id === 'Tire.TireType.name') {
                  Object.assign(newOjb, { tireTypeName: v.value })
                } else if (v.id === 'inventoryOptions[0].option1.optionName') {
                  Object.assign(newOjb, { width: v.value })
                } else if (v.id === 'inventoryOptions[0].option2.optionName') {
                  Object.assign(newOjb, { series: v.value })
                } else if (v.id === 'inventoryOptions[0].option3.optionName') {
                  Object.assign(newOjb, { rims: v.value })
                } else if (v.id === 'stockSummary') {
                  Object.assign(newOjb, { lowStock: v.value })
                } else if (v.id === 'supplier[0].name') {
                  Object.assign(newOjb, { supplierName: v.value })
                } else {
                  Object.assign(newOjb, { [v.id]: v.value })
                }
              })
              setCurrent(0)
              refetch(newOjb)
              setVariable(newOjb)
            }}
            onSortedChange={async (newSorted) => {
              setCurrent(0)
              refetch({
                orderBy: newSorted[0].desc ? 'DESC' : 'ASC',
                orderField: newSorted[0].id,
              })
            }}
          />
          {
            loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
          }
        </Div>
      }
    </Wrapper>
  )
}

export default Index
